
// inject scrollbar width as css variable on "html" element
// Can be used to add padding if html is set to overflow hidden.
// Should be updated automatically if the scrollbar width changes.
var scrollbarWidthSetter = () => {
    window.requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
    });
};
window.addEventListener('resize', scrollbarWidthSetter);
scrollbarWidthSetter();
